<template>
  <div class="header_box">
    <!-- 占位 -->
    <div class="header_wrapper_substitute"></div>
    <div class="header_wrapper">
      <div class="wrapper_box header_wrapper_box">
        <div class="logo">
          <router-link :to="'/'">
            <img src="@assets/image/common/logo.png" alt="" />
          </router-link>
        </div>
        <ul>
          <li
            v-for="(item, index) in navList"
            @click="eventOpenPage(item, index)"
            :key="index"
            :class="index == current ? 'active' : ''"
          >
            {{ item.name }}
            <div class="menu-list" v-if="item.children">
              <p
                v-for="(itemMenu, indexMenu) in item.children"
                :key="indexMenu"
                @click.stop="eventOpenPage(itemMenu, index)"
              >
                {{ itemMenu.name }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'headerName',
  components: {},
  data() {
    return {
      navList: [
        {
          path: '/',
          name: '首页',
        },
        {
          path: '/solution',
          name: '解决方案',
          details: 'solutionDetails',
        },
        {
          path: '/product',
          name: '产品',
          details: 'productDetails',
        },
        {
          path: '/case',
          name: '成功案例',
        },
        {
          path: '/technicalsupport',
          name: '技术支持',
        },
        {
          name: '关于我们',
          children: [
            {
              path: '/organizationintroduce',
              name: '业务介绍',
            },
            {
              path: '/aboutus',
              name: '联系我们',
            },
          ],
        },
      ],
      current: -1,
    }
  },
  watch: {
    $route: {
      handler: function (newVal) {
        this.navList.forEach((element, index) => {
          if (element.path == newVal.path || element.details == newVal.name) {
            this.current = index
          }
        })
      },
      // 深度观察监听
      deep: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    eventOpenPage(item, index) {
      if (item.name !== '关于我们') {
        this.current = index
      }
      if (!item.children) {
        this.$router.push(item.path)
      }
    },
  },
}
</script>

<style lang='scss' scope>
.header_box {
  height: 80px;
  .header_wrapper_substitute {
    height: 100%;
  }
  .header_wrapper {
    position: fixed;
    z-index: 999;
    height: 80px;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background: $color-white;
    box-shadow: 0px 7px 90px 0px rgba(0, 0, 0, 0.17);
    .header_wrapper_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo {
        img {
          height: 50px;
          border: none;
        }
      }
      ul {
        display: flex;
        font-size: $font-size-16;
        li {
          padding: 0 24px;
          line-height: 80px;
          cursor: pointer;
          position: relative;
          height: 100%;

          font-size: $font-size-18;
          font-weight: bold;
          .menu-list {
            position: absolute;
            left: 0;
            bottom: -101px;
            background: #fff;
            display: none;
            padding: 10px 0;
            width: 100%;
            border: 1px solid $border-color-base;
            border-top: none;
            p {
              display: block;
              text-align: center;
              font-size: $font-size-16;
              line-height: 40px;
              color: $color-text-regular;
              &:hover {
                color: $color-text-active !important;
              }
            }
          }
          &:hover {
            color: $color-text-active;
          }
          &:hover .menu-list {
            display: block;
          }
        }
        .active {
          font-weight: bold;
          color: $color-text-active;
        }
      }
    }
  }
}
@media screen and (max-width: 1439px) {
  .header_box {
    .header_wrapper {
      min-width: 1340px !important;
      position: absolute;
    }
  }
}
</style>